import React from 'react';
import MerchantDashboard from './MerchantDashboard';
import ExpertDashboard from './ExpertDashboard';
import InsuranceDashboard from './InsuranceDashboard';
import AdminDashboard from './AdminDashboard';
import { usePartyFlags } from 'lib/Hooks';

const Dashboard = ({ data, partyTypes, user, fetchData }) => {
  const { isExpert, isInsurance, isMerchant, isOperator } = usePartyFlags(
    user,
    partyTypes
  );

  React.useEffect(() => {
    fetchData();
  }, []); //eslint-disable-line

  return (
    <div>
      {isMerchant ? (
        <MerchantDashboard {...data} />
      ) : isExpert ? (
        <ExpertDashboard {...data} />
      ) : isInsurance ? (
        <InsuranceDashboard {...data} />
      ) : isOperator ? (
        <AdminDashboard {...data} />
      ) : (
        false
      )}
    </div>
  );
};

export default Dashboard;
